import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TimezoneFormComponent } from '../timezone-form/timezone-form.component';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'sphere-timezone-regions-formly-wrapper',
    templateUrl: './timezone-regions-formly-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TimezoneFormComponent, ReactiveFormsModule]
})
export class TimezoneRegionsFormlyWrapperComponent extends FieldType {
    constructor() {
        super();
    }

    get formGroup(): FormGroup {
        return this.form as FormGroup;
    }
}
